import Burgus from './Burgus';
import Mercure from './Mercure';
import DonaSofia from './DonaSofia';
import IbisCentro from './IbisCentro';
import IbisBudget from './IbisBudget';

export default {
  Burgus,
  Mercure,
  DonaSofia,
  IbisCentro,
  IbisBudget,
};



// WEBPACK FOOTER //
// ./src/components/Location/hotels/index.js